import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.background};
  border: 2px solid ${({ theme }) => theme.keyline};
  border-radius: 8px;
  color: ${({ theme }) => theme.textDark};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  background-color: ${({ theme }) => theme.keyline};
  padding: 18px 15px;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  align-items: center;
  font-family: ${platform.headingFont};
  justify-content: space-between;
  gap: 15px;

  svg {
    margin-right: 8px;
  }
`;

export const Title = styled.span`
  display: flex;
  align-items: center;
`;

export const Body = styled.div`
  padding: 0 15px;
  flex: 1;
`;

export const TitleRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const TextRow = styled.div`
  text-align: right;

  button {
    font-size: 16px;
    text-decoration: underline;
    text-align: right;
    color: ${({ theme }) => theme.textDark};

    &:hover {
      color: ${({ theme }) => theme.backgroundMid};
    }
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-top: 1px solid ${({ theme }) => theme.keyline};
  padding: 15px 0;
  gap: 15px;

  &:first-child {
    border-top: none;
  }
`;
